export default function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.6786 10.5C12.4325 9.525 12.8095 8.4 12.8095 7.125C12.8095 4.05 10.246 1.5 7.15476 1.5C4.06349 1.5 1.5 4.05 1.5 7.125C1.5 10.2 4.06349 12.75 7.15476 12.75C8.43651 12.75 9.64286 12.3 10.5476 11.625L14.6944 15.75L15.75 14.7L11.6786 10.5ZM7.15476 11.25C4.89286 11.25 3.00794 9.375 3.00794 7.125C3.00794 4.875 4.89286 3 7.15476 3C9.41667 3 11.3016 4.875 11.3016 7.125C11.3016 9.375 9.41667 11.25 7.15476 11.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
